import type { AdminRole } from '@/lib/api-admin/types';

/**
 * 아티스트 메뉴·쓰기 권한 — BE partner `/admin/v1/artists` 와 같게. QA-590 운영 관리자(OPS_ADMIN)는 역할 권한
 * 관리에서 아티스트 메뉴를 줄 수 있는데(Sidebar) 라우트 가드에 없어 "권한 없음"이었다 → 조회·쓰기 모두 포함(BE 허용).
 */
export const ARTIST_ROUTE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'MD_MANAGER',
  'OPS_ADMIN',
  'AUDITOR',
];

export const ARTIST_WRITE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'MD_MANAGER', 'OPS_ADMIN'];

export const canPerformArtistWrite = (roles: ReadonlyArray<AdminRole>): boolean =>
  ARTIST_WRITE_ROLES.some((r) => roles.includes(r));
